/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-12 10:02:31
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-05-06 18:25:58
 * @FilePath: /seller-station-client/src/container/mall/_layout/index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

import { Layout } from 'antd';
import { NestedRoute } from '@sniff/routeguard';
import Header from '@/common/layout/header';
import Footer from '@/common/layout/footer';

import SidebarTool from '@/common/layout/sidebarTool/Index';
import { rateInfo } from '@/atom/rate';

export default function () {
	// rateInfo();
	return (
		<Layout
			style={{ minHeight: '100vh' }}
			className=" bg-black-0 min-w-[1200px] relative "
			id="mall"
		>
			<SidebarTool />
			<div className="min-h-[640px]">
				<NestedRoute />
			</div>
			<Footer />
		</Layout>
	);
}
